// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.a387d0a1353a7cb1b84e49b778d682560c477080.js";
};